import { Injectable } from '@angular/core';

import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  private dbPath = '/users';

  objetoRef: AngularFirestoreCollection<any> = null;

  constructor(private db:AngularFirestore) {
    this.objetoRef = db.collection(this.dbPath);
  }

  getAll(): AngularFirestoreCollection<any>{
      return this.db.collection(this.dbPath, ref => ref.orderBy('name','asc'));
  }

  getUserByEmail(email:string): AngularFirestoreCollection<any>{
      return this.db.collection(this.dbPath, ref => ref.where('email','==', email));
  }
  
  nuevo(obj){
    let temp = { ...obj};
    delete temp.id;
    return this.objetoRef.add(temp);
  }
  
  edit(value, id){
    let temp = { ...value};
    delete temp.id;
    return this.objetoRef.doc(id).update(temp);
  }
  
  delete(id:string){
    return this.objetoRef.doc(id).delete();
  }

  getAuthorization(email:string, rol:string): Promise<boolean>{

    return new Promise((resolve, reject) => {

      try {
        
        this.getUserByEmail(email).snapshotChanges().pipe(
          map( changes =>
            changes.map( d =>
              ({ uid: d.payload.doc.id, ...d.payload.doc.data() })
            )
          )
        ).subscribe( user => {
  
          if(!user[0].roles){
            resolve(false);
          }
  
          let result = false;
          user[0].roles.forEach( r => {
            if(r == rol){
              result = true;
            }
          })
          resolve(result);  
        })


      } catch (error) {
        reject(false)
      }

    })
    
  }
}
